import { z } from 'zod';
import { displayRestrictionTypeSchema } from './display-restriction-type.schema';

export const coPilotOptionsSchema = z.object({
  displayRestrictions: displayRestrictionTypeSchema,
});

export type CoPilotOptions = z.infer<typeof coPilotOptionsSchema>;
